import type { UserPermission } from '@/shared/types/permissions';
import type { User } from '@/shared/types/user';

export const hasPermission = (user: User | null, permission: UserPermission): boolean => {
  if (!user?.permissions) return false;
  return user.permissions.includes(permission);
};
